import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import Home from './components/home.js'
import Login from './components/login.js'
import Signup from './components/signup.js'
import AdminSignups from './components/admin-signups.js'

function App () {
  return (
    <Routes>

      <Route
        path='/'
        element={<Home />}
      />

      <Route
        path='/login'
        element={<Login />}
      />

      <Route
        path='/signup'
        element={<Signup />}
      />

      <Route
        path='/admin/signups'
        element={<AdminSignups />}
      />

      <Route path='*' element={<Navigate to='/' />} />
    </Routes>

  )
}

export default App
